import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { GenerateJsonExcel } from './GenerateJsonExcel';

const GenerateExcel = (props) => {
  const [dataJsonExcel, setDataJsonExcel] = useState();
  //Función para pasar de coordenadas [0,0] a coordenadas de celda 'A1'
  function convertirCoordenada(coordenada) {
    const col = coordenada[0];
    const row = coordenada[1];
    const cell = XLSX.utils.encode_cell({ c: col, r: row });
    return cell;
  }

  //Función apra establecer el ancho de cada celda
  function anchoCelda(celdaAncho, worksheet) {
    let anchoNecesario = 35;
    worksheet.getColumn(celdaAncho).width = anchoNecesario;
  }

  //Función para rellenar las celdas en la hoja
  function llenarCeldas(seleccion, tipo, estilos, valor, combinado, worksheet) {
    //Creación de objeto con cada uno de los estilos de la celda
    const cellStyle = {
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: `${estilos.fondo}` },
      },
      font: {
        size: estilos.tamano,
      },
      border: {
        //Verifica si en desde el Json se seleccionaron bordes o no
        bottom: { style: `${estilos.borderButon ? 'thin' : ''}` },
        left: { style: `${estilos.borderLeft ? 'thin' : ''}` },
        top: { style: `${estilos.borderTop ? 'thin' : ''}` },
        right: { style: `${estilos.borderRigth ? 'thin' : ''}` },
        color: { argb: '000000' },
      },
      alignment: {
        horizontal: `${estilos.alineacion}`,
        vertical: 'middle',
        wrapText: true,
        textRotation: 0,
      },
    };

    //Inicio de creación de celdas
    if (tipo == 'rango' && seleccion.length == 2) {
      const ubicacionInicial = convertirCoordenada(seleccion[0]);
      const ubicacionFinal = convertirCoordenada(seleccion[1]);
      //Validación de combinación de celdas

      if (combinado == true) {
        const [startCell, endCell] = seleccion;
        const [startColumn, startRow] = startCell;
        const [endColumn, endRow] = endCell;

        // Itera sobre los valores y escribe en las celdas correspondientes
        for (let row = startRow; row <= endRow; row++) {
          for (let col = startColumn; col <= endColumn; col++) {
            const cell = convertirCoordenada([col, row]);
            anchoCelda(cell.substring(0, 1), worksheet);
          }
        }

        worksheet.getCell(`${ubicacionInicial}`).style = cellStyle;
        worksheet.mergeCells(`${ubicacionInicial}:${ubicacionFinal}`);
        worksheet.getCell(`${ubicacionInicial}`).value = `${valor}`;
      }
      //La ejecución se realiza cuando la variable combinado sea false
      else if (combinado === false) {
        debugger;
        //Genera variables que contedran el inicio y el fin de las celdas que se rellenarán
        const [startCell, endCell] = seleccion;
        const [startColumn, startRow] = startCell;
        const [endColumn, endRow] = endCell;

        // Itera sobre los valores y escribe en las celdas correspondientes
        let valorIndex = 0;
        for (let row = startRow; row <= endRow; row++) {
          for (let col = startColumn; col <= endColumn; col++) {
            if (valorIndex < valor.length) {
              const valorActual = valor[valorIndex];
              const cell = convertirCoordenada([col, row]);
              worksheet.getCell(cell).style = cellStyle;
              worksheet.getCell(cell).value = `${valorActual}`;
              anchoCelda(cell.substring(0, 1), worksheet);
              valorIndex++;
            } else {
              break;
            }
          }
        }
      }
    } else if (tipo == 'celda' && seleccion.length == 1) {
      //Conversión de coordenadas
      const ubicacionInicial = convertirCoordenada(seleccion[0]);

      worksheet.getCell(`${ubicacionInicial}`).style = cellStyle;
      worksheet.getCell(`${ubicacionInicial}`).value = `${valor}`;

      anchoCelda(ubicacionInicial.substring(0, 1), worksheet);
    } else {
      console.log('Ingrese un tipo y selección Válido');
    }
  }

  //Función para generar el excel
  const crearExcel = async (jsonExcel) => {
    //Creación de nuevo libro de excel
    const workbook = new ExcelJS.Workbook();

    //Creación de nueva hoja
    const worksheet = workbook.addWorksheet('Hoja1');
    //props.jsonExcel.forEach((element) => {...

    //Lectura de Json a paritr de un For Each
    jsonExcel.forEach((element) => {
      const seleccion = element.seleccion;

      // Accede a los valores de cada propiedad en el elemento actual
      const tipo = element.tipo;
      const estilos = element.estilos;
      const valor = element.valor;
      const combinado = element.combinado;

      llenarCeldas(seleccion, tipo, estilos, valor, combinado, worksheet);
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${props.nombre}_${props.numero}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  function generateExcel() {
    let dataJs;
    if (props.indicador === '1') {
      dataJs = {
        indicador: props.indicador,
        nombre: props.nombre,
        numero: props.numero,
        fecha: props.fecha,
        salTotal: props.salDispo,
        salDispo: props.salTotal,
        supervision: props.supervision,
        listMov: [],
      };

      props.movCuenta.map((item) => {
        dataJs.listMov.push({
          fecha: item.transactionDate,
          tipo: 'Pago Interes',
          descripcion: item.transactionName,
          monto: item.transactionBalance,
        });
      });
    } else {
      dataJs = {
        indicador: props.indicador,
        nombre: props.nombre,
        numero: props.numero,
        fecha: props.fecha,
        deuda: props.deuda,
        pagoTotalFecha: props.pagoTotalFecha,
        pagoMinimoFecha: props.pagoMinimoFecha,
        listMov: [],
      };

      props.movCuenta.map((item) => {
        dataJs.listMov.push({
          fecha: item.transactionDate,
          descripcion: item.transactionName,
          monto: item.transactionBalance,
        });
      });
    }
    console.log(
      'Este es el json  con la data de la cuenta: ' +
        JSON.stringify(dataJs, null, 2)
    );
    crearExcel(GenerateJsonExcel(dataJs));
  }

  return (
    <>
      <div>
        <button onClick={generateExcel} className="btn btn-success">
          <i class="fas fa-file-download"></i>
        </button>
      </div>
    </>
  );
};
export default GenerateExcel;
